import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseScheduleQualityTrendProvider } from 'components/widgets/ScheduleQualityTrend/ScheduleQualityTrend.provider';

interface Props {
    setIsPayloadReady?: (isPayloadReady: boolean) => void;
    widgetViewMode?: WidgetViewMode;
    api: UseScheduleQualityTrendProvider['api'];
}

export const useScheduleQualityTrendLogic = ({ api, widgetViewMode, setIsPayloadReady }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getScheduleQualityTrend.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        )
            return;
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
};
